import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertSuccessNotifyNoOverlayClose from "components/DialogAlertNotify/DialogAlertSuccessNotify/DialogAlertSuccessNotifyNoOverlayClose";
import { Report } from "./styles";

const SyncEventUnprocessedDialog = ({
    syncOfEventUnprocessed,
    fillEventList
}) => {
    const closeDialog = () => {
        syncOfEventUnprocessed.dialogShow.toggle(false);
        fillEventList();
    }
    return (
        <DialogAlertSuccessNotifyNoOverlayClose
            closeDialog={() => { /* Para que no se cierre el modal */}}
            variant="secondary"
            dialogShow={syncOfEventUnprocessed.dialogShow}
            title="La sincronización ha terminado correctamente"
            contentComponent={<Content data={syncOfEventUnprocessed.data}/>}>
            <CustomButton 
                text="Cerrar" 
                onClick={closeDialog}/>
        </DialogAlertSuccessNotifyNoOverlayClose>
    );
}

function Content({
    data
}) {
    if (!data) return;
    const {
        processed, 
        unprocessed,
        pending
    } = data;
    return (
        <Report className="list paragraph">
            <li>{processed} <b>procesado(s)</b></li>
            <li>{unprocessed} <b>no procesado(s)</b></li>
            <li>{pending} <b>pendiente(s)</b></li>
        </Report>
    );
}

export default SyncEventUnprocessedDialog;